/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../base';
// @ts-ignore
import type { GetPresignedUrlInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetPresignedUrlNotFoundDto } from '../../src/model';
// @ts-ignore
import type { GetPresignedUrlOkDto } from '../../src/model';
/**
 * ImageUrlApi - axios parameter creator
 * @export
 */
export const ImageUrlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 이미지 경로 조회
         * @param {ImageServerControllerGetPresignedUrlCategoryNameEnum} categoryName 카테고리 이름
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageServerControllerGetPresignedUrl: async (categoryName: ImageServerControllerGetPresignedUrlCategoryNameEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryName' is not null or undefined
            assertParamExists('imageServerControllerGetPresignedUrl', 'categoryName', categoryName)
            const localVarPath = `/image-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (categoryName !== undefined) {
                localVarQueryParameter['categoryName'] = categoryName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ImageUrlApi - functional programming interface
 * @export
 */
export const ImageUrlApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ImageUrlApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 이미지 경로 조회
         * @param {ImageServerControllerGetPresignedUrlCategoryNameEnum} categoryName 카테고리 이름
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async imageServerControllerGetPresignedUrl(categoryName: ImageServerControllerGetPresignedUrlCategoryNameEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPresignedUrlOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.imageServerControllerGetPresignedUrl(categoryName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImageUrlApi.imageServerControllerGetPresignedUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ImageUrlApi - factory interface
 * @export
 */
export const ImageUrlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ImageUrlApiFp(configuration)
    return {
        /**
         * 
         * @summary 이미지 경로 조회
         * @param {ImageUrlApiImageServerControllerGetPresignedUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageServerControllerGetPresignedUrl(requestParameters: ImageUrlApiImageServerControllerGetPresignedUrlRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetPresignedUrlOkDto> {
            return localVarFp.imageServerControllerGetPresignedUrl(requestParameters.categoryName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for imageServerControllerGetPresignedUrl operation in ImageUrlApi.
 * @export
 * @interface ImageUrlApiImageServerControllerGetPresignedUrlRequest
 */
export interface ImageUrlApiImageServerControllerGetPresignedUrlRequest {
    /**
     * 카테고리 이름
     * @type {'profile' | 'community' | 'viewing' | 'banner'}
     * @memberof ImageUrlApiImageServerControllerGetPresignedUrl
     */
    readonly categoryName: ImageServerControllerGetPresignedUrlCategoryNameEnum
}

/**
 * ImageUrlApi - object-oriented interface
 * @export
 * @class ImageUrlApi
 * @extends {BaseAPI}
 */
export class ImageUrlApi extends BaseAPI {
    /**
     * 
     * @summary 이미지 경로 조회
     * @param {ImageUrlApiImageServerControllerGetPresignedUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImageUrlApi
     */
    public imageServerControllerGetPresignedUrl(requestParameters: ImageUrlApiImageServerControllerGetPresignedUrlRequest, options?: RawAxiosRequestConfig) {
        return ImageUrlApiFp(this.configuration).imageServerControllerGetPresignedUrl(requestParameters.categoryName, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ImageServerControllerGetPresignedUrlCategoryNameEnum = {
    Profile: 'profile',
    Community: 'community',
    Viewing: 'viewing',
    Banner: 'banner'
} as const;
export type ImageServerControllerGetPresignedUrlCategoryNameEnum = typeof ImageServerControllerGetPresignedUrlCategoryNameEnum[keyof typeof ImageServerControllerGetPresignedUrlCategoryNameEnum];
